import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSaucelabsComponent } from './simple-icons-saucelabs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSaucelabsComponent ],
    exports:      [ SimpleIconsSaucelabsComponent ],
    bootstrap:    []
})
export class SimpleIconsSaucelabsModule {}
